import { CAROUSEL } from '../actions/carousel';

export const InitialState = {
    activeIndex: 1
};

// REDUCERS
// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = InitialState, action) {
    switch (action.type) {
        case CAROUSEL.SET_INDEX:
            return Object.assign({}, state, {
                activeIndex: action.activeIndex
            });

        default:
            return state
    }
}